import { useEffect, useRef, useState } from "react";

const sectionsData = [
  {
    id: "services",
    title: "Services",
    content: (
      <ul className="tl ml4">
        <li>Data processing</li>
        <li>Cloud data management</li>
        <li>Information communication</li>
        <li>Agricultural e-learning</li>
      </ul>
    ),
    icon: "https://img.icons8.com/ios-filled/50/services.png",
  },
  {
    id: "vision",
    title: "Vision",
    content: (
      <p>
        To nurture a winning network by building bonds for long-term value in
        the value chain.
      </p>
    ),
    icon: "https://img.icons8.com/ios-filled/50/binoculars.png",
  },
  {
    id: "mission",
    title: "Mission",
    content: (
      <p>
        To enhance, empower and connect through technology to create worth and
        make a distinction.
      </p>
    ),
    icon: "https://img.icons8.com/?size=100&id=uCdiNkAPKcIG&format=png&color=000000",
  },
  {
    id: "aims",
    title: "AIMS",
    content: (
      <p>
        To build bonds through technology in order to create worth in the Value
        chain network.
      </p>
    ),
    icon: "https://img.icons8.com/ios-filled/50/goal.png",
  },
];

export default function AnimatedServices() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [progress, setProgress] = useState(0);
  const touchStartX = useRef(null);
  const SLIDE_DURATION = 5000;

  useEffect(() => {
    let interval;
    let progressInterval;

    if (!isPaused) {
      interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % sectionsData.length);
        setProgress(0);
      }, SLIDE_DURATION);

      progressInterval = setInterval(() => {
        setProgress((prev) => (prev >= 100 ? 0 : prev + 2));
      }, SLIDE_DURATION / 50);
    }

    return () => {
      clearInterval(interval);
      clearInterval(progressInterval);
    };
  }, [isPaused]);

  const scrollToSection = (index) => {
    setCurrentSlide(index);
    setProgress(0);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const delta = touchStartX.current - touchEndX;

    if (delta > 50) {
      setCurrentSlide((prev) => (prev + 1) % sectionsData.length);
      setProgress(0);
    } else if (delta < -50) {
      setCurrentSlide(
        (prev) => (prev - 1 + sectionsData.length) % sectionsData.length
      );
      setProgress(0);
    }
  };

  return (
    <div
      className="services-section bg-white pv3 ph3 ph4-l relative"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        className="relative w-100 center overflow-hidden"
        style={{ minHeight: "250px"}} // ✅ Ensures content is visible
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {sectionsData.map((section, index) => (
          <div
            key={section.id}
            className="absolute top-0 left-0 w-100 flex justify-center items-center transition-opacity"
            style={{
              opacity: index === currentSlide ? 1 : 0,
              zIndex: index === currentSlide ? 10 : 0,
              transition: "opacity 0.6s ease",
              pointerEvents: index === currentSlide ? "auto" : "none",
            }}
          >
            <div
              className="w-95 w-95-m w-95-l pa5 br3 shadow-5 bg-white tc"
              style={{
                border: "2px solid #fc9c1c",
                color: "#fc9c1c",
              }}
            >
              <img
                src={section.icon}
                alt={`${section.title} icon`}
                className="h3 w3 mb3 center gold"
              />
              <h3 className="f3 fw6 mb3 tracked dark-gold">
                {section.title}
              </h3>
              <div className="services__service--text">{section.content}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Dots + Progress Bar */}
      <div className="flex justify-center mt1 items-center">
        {sectionsData.map((_, i) => (
          <div key={i} className="flex flex-column items-center mh2">
            <button
              onClick={() => scrollToSection(i)}
              className={`pointer bw0 bg-transparent pa0 ${
                currentSlide === i ? "o-100" : "o-30"
              }`}
              title={`Go to ${sectionsData[i].title}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h1 w1 black"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="6" />
              </svg>
            </button>
            <div className="w2 h05 bg-black mt1 br-pill overflow-hidden">
              <div
                className="bg-black h-50 br-pill"
                style={{
                  width: currentSlide === i ? `${progress}%` : "0%",
                  transition: "width 0.1s linear",
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
